module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_fails.js
// module id = ./node_modules/core-js/library/modules/_fails.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons